const presetsForCT = [
	{ name: 'CT Default', type: 'CT-AAA' },
	{ name: 'CT AAA', type: 'CT-AAA' },
	{ name: 'CT Bone', type: 'CT-Bone' },
	{ name: 'CT Cardiac', type: 'CT-Cardiac' },
	{ name: 'CT Vessel1', type: 'CT-Chest-Vessels' },
	{ name: 'CT Lung', type: 'CT-Lung' },
	{ name: 'CT MIP', type: 'CT-MIP' },
	{ name: 'CT Air', type: 'CT-Air' },
	{ name: 'Coronary Arteries', type: 'CT-Coronary-Arteries' }
];

const presetsForMR = [
	{ name: 'MR Angio', type: 'MR-Angio' },
	{ name: 'MR T2 Brain', type: 'MR-T2-Brain' },
	{ name: 'MR Default', type: 'MR-Default' },
	{ name: 'MR MIP', type: 'MR-MIP' },
	{ name: 'MR TOF GE', type: 'MR-Default-TOF-GE' },
	{ name: 'MR TOF Hitachi', type: 'MR-Default-TOF-Hitachi' },
	{ name: 'MR TOF Philips', type: 'MR-Default-TOF-Philips' },
	{ name: 'MR TOF Siemens', type: 'MR-Default-TOF-Siemens' },
	{ name: 'MR TOF UIH', type: 'MR-Default-TOF-UIH' }
];

/**
 *  lấy các data preset 3d theo máy chụp
 */
export const getThreeDimensionPresets = (modality) => {
	switch (modality) {
		case 'CT':
			return presetsForCT;
		case 'MR':
			return presetsForMR;
		default:
			break;
	}
};
